import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../../env";
import axiosInstance from "../../../../globalInspector/axiosInstance";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const getEntities = createAsyncThunk(
  "getEntities",
  async (values, { rejectWithValue }) => {
    const { page_no, page_size, search_string, entity_id, pan } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/entities`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no: page_no,
          page_size: page_size,
          search_string: search_string,
          entity_id: entity_id,
          ...(pan && { pan: pan }),
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

export const getUserSpecificEntity = createAsyncThunk(
  "getUserSpecificEntity",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/entities`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

export const updateEntities = createAsyncThunk(
  "updateEntities",
  async (values, { rejectWithValue }) => {
    const entities = JSON.parse(sessionStorage?.getItem("response"))?.entity
      ?.entity_id;

    const {
      entity_name,
      entity_pan,
      entity_address,
      entity_pincode,
      entity_activate_date,
      cin_number,
      acquired_by,
      field_force_limit,
    } = values;

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/entities/${entities}`,
        {
          entity_name,
          entity_pan,
          entity_address,
          entity_pincode,
          entity_activate_date,
          cin_number,
          acquired_by,
          field_force_limit,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      let errorMessage;

      if (error.response) {
        errorMessage =
          error.response.data?.error ||
          error.response.data?.errors?.[0] ||
          "Something went wrong";
      } else {
        errorMessage = error.message;
      }

      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

const entitiesSlice = createSlice({
  name: "entities",
  initialState: {
    isLoading: false,
    entities: null,
    grades: [],
    isError: false,
    createEntityRes: null,
    updateEntityData: null,
    updateEntityLoading: false,
    updateEntityError: null,
    getEntityData: null,
    getEntityLoading: false,
    getEntityError: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getEntities.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getEntities.fulfilled, (state, action) => {
      state.isLoading = false;
      state.entities = action.payload;
      try {
        state.grades = action.payload?.entities[0]?.grades;
      } catch {}
    });
    builder.addCase(getEntities.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });

    // UPDATE ENTITY
    builder.addCase(updateEntities.pending, (state) => {
      state.updateEntityLoading = true;
      state.updateEntityError = null;
    });

    builder.addCase(updateEntities.fulfilled, (state, action) => {
      state.updateEntityLoading = false;
      state.updateEntityData = action.payload;
    });

    builder.addCase(updateEntities.rejected, (state, action) => {
      state.updateEntityLoading = false;
      state.updateEntityError = action.payload;
    });

    // GET ENTITY
    builder.addCase(getUserSpecificEntity.pending, (state) => {
      state.getEntityLoading = true;
      state.getEntityError = null;
    });

    builder.addCase(getUserSpecificEntity.fulfilled, (state, action) => {
      state.getEntityLoading = false;
      state.getEntityData = action.payload;
    });

    builder.addCase(getUserSpecificEntity.rejected, (state, action) => {
      state.getEntityLoading = false;
      state.getEntityError = action.payload;
    });
  },
});

export default entitiesSlice.reducer;
